var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center w-100 h-100"},[(_vm.showError)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.$t('sentence.something_went_wrong'))+" ")]):_c('v-loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }